export default __webpack_public_path__ + "static/media/ps-LightSwitch1.17eafa31.png";